module.exports = __webpack_public_path__ + "static/media/workingOut.010c0ff8.svg";